<template>
  <div>
    <div class="full-height" v-loading="containerImagesListReqStatus === 'loading'">
      <el-row type="flex" class="account-summary__row" v-if="containerImagesListReqStatus === 'saved'">
        <el-col :span="3">
          <div class="display-inline-block">
            <span class="display-block title capitalize-first-letter">CONTAINER IMAGES</span>
            <span class="display-block count"
              >{{ containerImagesListSummary.containerCount || 0 }}
              <!-- <i class="fal fa-exclamation-triangle" v-if="containerImagesListSummary.unprotectedCount > 0"></i> -->
            </span>
            <router-link v-if="$allow('network', 'write')" :to="{ name: 'installation', query: { os: 'kubernetes' } }">
              <a class="display-inline-block">add containers</a>
            </router-link>
            <br v-else />
          </div>
        </el-col>
        <el-col :span="4">
          <el-divider direction="vertical"></el-divider>
          <div class="display-inline-block">
            <span class="display-block title capitalize-first-letter">NEEDS ATTENTION</span>
            <span class="display-block count">{{ containerImagesListSummary.needsAttentionCount || 0 }}</span>
            <span class="text-btn" @click="loadDocumentation('page-container-images')">Learn More</span>
          </div>
        </el-col>
        <el-col :span="4">
          <el-divider direction="vertical"></el-divider>
          <div class="display-inline-block">
            <span class="display-block title capitalize-first-letter">PROGRESSIONS</span>
            <span class="display-block count">{{ containerImagesListSummary.progressionCount || 0 }}</span>
            <router-link :to="{ name: 'active-cyber-attacks' }"
              ><a class="display-inline-block">investigate</a>
            </router-link>
          </div>
        </el-col>
        <el-col :span="4">
          <el-divider direction="vertical"></el-divider>
          <div class="display-inline-block">
            <el-tooltip placement="top">
              <div slot="content">
                <span class="vulnerable-tooltip"
                  ><span style="font-weight:bold;">Vulnerable</span><br />Go to synk to<br />mitigate vulnerable<br />container
                  images</span
                >
              </div>
              <span class="display-block title capitalize-first-letter">VULNERABLE</span>
            </el-tooltip>
            <span class="display-block count">{{ containerImagesListSummary.snykVulernableCount || 0 }}</span>
            <a class="display-inline-block" href="https://app.snyk.io/login" target="_blank" rel="noreferrer">
              go to Snyk
            </a>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="float-right info-buttons">
            <el-button class="help-button" size="small" style="background: white">
              <el-link @click="loadDocumentation('page-container-images')" :underline="false">
                User Guide
              </el-link>
            </el-button>
            <el-dropdown v-if="$allow('network', 'write')">
              <span class="el-dropdown-link">
                <el-button class="add-button" size="small">
                  Add Containers
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div class="box flex align-center gaps" @click="gotoConfigure('aws')">
                    <span class="box body1">EKS</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="box flex align-center gaps" @click="gotoConfigure('aws')">
                    <span class="box body1">AKS</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="box flex align-center gaps" @click="gotoConfigure('aws')">
                    <span class="box body1">GKE</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="box flex align-center gaps" @click="gotoConfigure('worker')">
                    <span class="box body1">Worker Node</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
      </el-row>

      <div class="table-toolbar" v-if="containerImagesListReqStatus === 'saved'">
        <table-toolbar
          ref="hostTableToolbar"
          v-if="apiCalled"
          :key="containerImagesListInfo.key"
          :search-properties="visibleHostsColumns"
          :total-search-properties="hostsColumns"
          :search-data="containerImagesListInfo"
          :initial-tags="containerImagesListInfo.searchTags"
          :active-filter-data="activeFiltersData"
          :reload-component="containerImagesListInfo.reloadToolbar"
          :disable-search-box="disableSearchBox"
          @update-querydata="updateTableQueryData"
          @refresh-tabledata="refreshTableData"
          @update-columns-data="modifyColumnsData"
          @add-searchtags="addSearchTags"
          @deactivate-filter="deactivateFilter"
        >
          <div slot="left-toolbar-tools" class="filter-button-group">
            <el-button
              size="small"
              round
              :class="{ active: hostFiltersSelected.includes('all') }"
              @click.native="changeFilterSelection('all')"
            >
              All
            </el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              round
              :class="{ active: hostFiltersSelected.includes('high') }"
              @click.native="changeFilterSelection('high')"
            >
              Highly Vulnerable
            </el-button>
            <el-button
              size="small"
              round
              :class="{ active: hostFiltersSelected.includes('progressions') }"
              @click.native="changeFilterSelection('progressions')"
            >
              Has Progressions
            </el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              round
              :class="{ active: filtersSelected.includes('eks') }"
              @click.native="changeFilterSelection('eks')"
            >
              EKS
            </el-button>
            <el-button
              size="small"
              round
              :class="{ active: filtersSelected.includes('gke') }"
              @click.native="changeFilterSelection('gke')"
            >
              GKE
            </el-button>
            <el-button
              size="small"
              round
              :class="{ active: filtersSelected.includes('aks') }"
              @click.native="changeFilterSelection('aks')"
            >
              AKS
            </el-button>
            <!-- <el-button size="small" round>
              Pinned
            </el-button> -->
            <!-- <el-button size="small" round>
              More Filters
            </el-button> -->
            <el-divider direction="vertical"></el-divider>
            <span v-if="filterList.length">
              <div class="display-inline mr-18 relative-pos" v-for="(btn, index) in filterList" :key="index">
                <el-input
                  ref="customFilterInput"
                  class="filter-input"
                  v-if="btn.editFlag"
                  placeholder="+Name"
                  v-model="btn.name"
                  @change.native.stop="handleFilterNameChange(btn)"
                  @keyup.native.enter="handleFilterNameChange(btn)"
                  @blur="handleFilterNameChange(btn)"
                ></el-input>
                <el-button
                  v-else
                  size="small"
                  round
                  :class="{ active: btn.active }"
                  :id="btn.id"
                  @click="changeState(btn)"
                >
                  {{ btn.name }}
                  <el-tooltip class="item" effect="dark" content="Edit or Delete" placement="bottom">
                    <span>
                      <i class="el-icon-edit el-icon--right" @click.stop="editFilter(btn)"></i>
                      <i class="el-icon-close el-icon--right" @click.stop="removeBtnFromList(btn, index)"></i>
                    </span>
                  </el-tooltip>
                </el-button>

                <span v-if="btn.errFlag" class="filter-name-validator">{{ filterErrMsg }}</span>
              </div>
            </span>
          </div>
          <div slot="local-actions">
            <el-button-group>
              <el-tooltip class="item" effect="dark" content="Host Details" placement="top" :enterable="false">
                <el-button
                  type="text"
                  class="cursor-pointer"
                  :class="{
                    'display-none': !displayTableActions.show && !displayTableActions.singleSelect,
                    disabled: displayTableActions.multiselect
                  }"
                  @click="openDetails"
                >
                  <i class="material-icons c-icon">info</i>
                </el-button>
              </el-tooltip>
            </el-button-group>
          </div>
        </table-toolbar>
      </div>

      <expandable-table-element
        class="containerlist-table"
        v-if="containerImagesListReqStatus === 'saved' && apiCalled"
        ref="containerlistTable"
        :columns="visibleHostsColumns"
        :table-data="containerImagesListInfo"
        :height-offset="40"
        @update-record-count="recordCountHandler"
        @table-selection-change="checkTableSelectionChanges"
      ></expandable-table-element>
    </div>

    <aside-sidebar
      parent=".layout-container"
      sibling=".containerlist-table"
      v-model="hideHostDetails"
      v-if="containerImagesListReqStatus === 'saved'"
    >
      <div slot="title">
        <h2 class="mv-0">{{ agentSelected.customHostname || agentSelected.agentId }}</h2>
      </div>
      <host-details-feed slot="content" :host-details="agentSelected"></host-details-feed>
    </aside-sidebar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HostStatusEnum } from '@/constants/host-status.constants'
import { OnOffEnum } from '@/constants/on-off.constants'
import { CriticalityLevelEnum } from '@/constants/criticality.constants'
import { containerImagesDetailMetaInfo } from '@/column-header/hosts/container-images-meta'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import ExpandableMultiSelectTableElement from '@/components/table/ExpandableMultiSelectTableElement.vue'
import ExpandableTableElement from '@/components/table/ExpandableTableElement.vue'
import AsideSidebar from '@/components/layout/AsideSidebar.vue'
import HostDetailsFeed from '@/components/feed/HostDetailsFeed.vue'

import {
  CONTAINER_IMAGES_LIST_REQ,
  CONTAINER_PROGRESSION_COUNT_REQ,
  AGENT_LIST_REQ,
  CONTAINER_IMAGES_VIEW_PREFERENCES,
  SAVE_CONTAINER_IMAGES_VIEW_PREFERENCES
} from '@/store/modules/agents/agents.type'
import { PREFERENCE_STORE_REQ } from '@/store/modules/column-preference/column-preference.type'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
import customFilterMixin from '@/mixins/customFilterMixin'

export default {
  name: 'ContainerImagesListView',
  mixins: [loadDocumentationMixin, customFilterMixin],
  data () {
    return {
      tableName: 'ContainerImages',
      containerColumnPrefs: {},
      breadcrumbs: [{ title: 'Containers' }],
      hostsColumns: containerImagesDetailMetaInfo.meta.columns,
      visibleHostsColumns: [],
      openCustomHostnameDialogVisible: false,
      openCriticalityDialogVisible: false,
      openDecommissionDialogVisible: false,
      hideHostDetails: true,
      displayTableActions: {
        show: false,
        singleSelect: false, // only enabled for 1 row
        multiselect: false // enabled for 1 or more row,
      },
      rowsSelected: {},
      agentSelected: {},
      criticalityForm: {},
      apiCalled: false,
      decommissionHostsSelection: {
        agents: [],
        error: ''
      },
      customHostnameRules: {
        customHostname: [
          {
            required: true,
            message: "Name can't be blank",
            trigger: 'blur'
          }
        ]
      },
      changeFilterSelection: {},
      hostFiltersSelected: ['all'],
      filtersSelected: [],
      containerPreferencesFetched: false,
      tblId: 19
    }
  },
  methods: {
    filterTableBy (filterField) {
      switch (filterField) {
        case 'all':
          if (!this.hostFiltersSelected.includes('all')) {
            this.hostFiltersSelected.splice(0, 1, 'all')
            this.filtersSelected.length = 0
            this.containerImagesListInfo.resetFilteredObjectAndSearch()
          }
          break
        case 'high':
          if (!this.hostFiltersSelected.includes('high')) {
            let currFilter = this.hostFiltersSelected[0]
            this.hostFiltersSelected.splice(0, 1, 'high')
            if (currFilter === 'progressions') {
              this.containerImagesListInfo.removeFilteredObjectAndSearch('hasProgressions', 'true')
            }
            this.containerImagesListInfo.filterDataByProperty('vulnerable', 'HIGH')
          }
          break
        case 'progressions':
          if (!this.hostFiltersSelected.includes('progressions')) {
            let currFilter = this.hostFiltersSelected[0]
            this.hostFiltersSelected.splice(0, 1, 'progressions')
            if (currFilter === 'high') {
              this.containerImagesListInfo.removeFilteredObjectAndSearch('vulnerable', 'HIGH')
            }
            this.containerImagesListInfo.filterDataByProperty('hasProgressions', 'true')
          }
          break
        case 'eks':
          if (!this.filtersSelected.includes('eks')) {
            this.filtersSelected.push('eks')
            this.containerImagesListInfo.filterDataByProperty('eks', 'true')
          } else {
            let found = _.indexOf(this.filtersSelected, 'eks')
            if (found > -1) {
              this.filtersSelected.splice(found, 1)
              this.containerImagesListInfo.removeFilteredObjectAndSearch('eks', 'true')
            }
          }
          break
        case 'gke':
          if (!this.filtersSelected.includes('gke')) {
            this.filtersSelected.push('gke')
            this.containerImagesListInfo.filterDataByProperty('gke', 'true')
          } else {
            let found = _.indexOf(this.filtersSelected, 'gke')
            if (found > -1) {
              this.filtersSelected.splice(found, 1)
              this.containerImagesListInfo.removeFilteredObjectAndSearch('gke', 'true')
            }
          }
          break
        case 'aks':
          if (!this.filtersSelected.includes('aks')) {
            this.filtersSelected.push('aks')
            this.containerImagesListInfo.filterDataByProperty('aks', 'true')
          } else {
            let found = _.indexOf(this.filtersSelected, 'aks')
            if (found > -1) {
              this.filtersSelected.splice(found, 1)
              this.containerImagesListInfo.removeFilteredObjectAndSearch('aks', 'true')
            }
          }
          break
        case 'vulnerable':
          if (!this.filtersSelected.includes('vulnerable')) {
            this.filtersSelected.push('vulnerable')
            this.containerImagesListInfo.filterDataByProperty('vulnerable', 'HIGH')
          } else {
            let found = _.indexOf(this.filtersSelected, 'vulnerable')
            if (found > -1) {
              this.filtersSelected.splice(found, 1)
              this.activeAgentList.removeFilteredObjectAndSearch('vulnerable', 'HIGH')
            }
          }
          break
      }
      this.updateTableQueryData()
      if (this.$refs['hostTableToolbar']) {
        this.$refs['hostTableToolbar'].setQueryCountText()
      }
    },
    gotoConfigure (name) {
      switch (name) {
        case 'aws':
          this.$router.push({
            name: 'installation',
            query: { os: 'kubernetes' }
          })
          break
        case 'worker':
          this.$router.push({
            name: 'installation'
          })
          break
      }
    },
    checkTableSelectionChanges () {
      if (_.isEmpty(this.$refs.containerlistTable.rowsSelected)) {
        this.displayTableActions.show = false
        this.displayTableActions.singleSelect = false
        this.displayTableActions.multiselect = false
      } else if (this.$refs.containerlistTable.rowsSelected.length === 1) {
        this.displayTableActions.show = true
        this.displayTableActions.singleSelect = true
        this.displayTableActions.multiselect = false
      } else {
        this.displayTableActions.show = true
        this.displayTableActions.singleSelect = false
        this.displayTableActions.multiselect = true
      }
    },
    openDetails () {
      if (
        _.isEmpty(this.$refs.containerlistTable.rowsSelected) ||
        this.$refs.containerlistTable.rowsSelected.length > 1
      ) {
        return false
      }
      this.agentSelected = _.cloneDeep(this.$refs.containerlistTable.rowsSelected[0])
      this.hideHostDetails = false
    },
    updateTableQueryData () {
      if (this.$refs.containerlistTable) {
        this.$refs.containerlistTable.updateTableData()
      }
    },
    recordCountHandler () {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.containerImagesListInfo.key = !this.containerImagesListInfo.key
      this.containerImagesListInfo.reloadToolbar = false
    },
    modifyColumnsData (selectedColumns) {
      this.containerColumnPrefs.userId = this.userProfile.id
      this.containerColumnPrefs.tblName = this.tableName
      this.containerColumnPrefs.preferedCols = selectedColumns
      this.containerColumnPrefs.tblId = 19 // For Mapping with database tables

      this.visibleHostsColumns = this.containerImagesListInfo.updateVisibleColumns(this.hostsColumns, selectedColumns)

      // store preferences in db
      this.$store.dispatch(SAVE_CONTAINER_IMAGES_VIEW_PREFERENCES, this.containerColumnPrefs).then(data => {
        // store preferences in vuex
        this.containerColumnPrefs.preferedCols = this.visibleHostsColumns
        this.$store.dispatch(PREFERENCE_STORE_REQ, this.containerColumnPrefs)
      })

      this.containerColumnPrefs.preferedCols = this.visibleHostsColumns
    },
    callApi (tableMetaData) {
      return new Promise((resolve, reject) => {
        Promise.all([
          this.$store.dispatch(AGENT_LIST_REQ),
          this.$store.dispatch(CONTAINER_PROGRESSION_COUNT_REQ),
          this.$store.dispatch(CONTAINER_IMAGES_LIST_REQ)
        ])
          .then(agents => {
            this.containerImagesListInfo.models.forEach(container => {
              let containerAgent = this.agentList.models.find((agent, idx) => {
                return container.agentId === agent.agentId
              })
              if (containerAgent) {
                container.stringify = `${containerAgent.customHostname},` + container.stringify
              }
            })

            this.apiCalled = true
            this.setTableMetaData(tableMetaData)
            if (this.hostFiltersSelected.includes('active')) {
              this.hostFiltersSelected.length = 0
              this.filterTableBy('active')
            } else if (this.hostFiltersSelected.includes('terminated')) {
              this.hostFiltersSelected.length = 0
              this.filterTableBy('terminated')
            }
            if (this.filtersSelected.length > 0) {
              let cloneFiltersSelected = _.clone(this.filtersSelected)
              this.filtersSelected.length = 0
              cloneFiltersSelected.forEach(filter => {
                this.filterTableBy(filter)
              })
            }
            resolve(true)
          })
          .catch(errMsg => {
            reject(errMsg)
          })
      })
    },
    setTableMetaData (tableMetaData) {
      this.containerImagesListInfo.searchTags = tableMetaData.searchTags
      this.containerImagesListInfo.currentPage = tableMetaData.activePage
    },
    refreshTableData (tableMetaData) {
      this.apiCalled = false
      this.callApi(tableMetaData).then()
    },
    loadContainerColumnPreferences () {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleHostsColumns = this.userPref[this.userProfile.id][this.tableName]
        this.containerPreferencesFetched = true
        this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(CONTAINER_IMAGES_VIEW_PREFERENCES, this.userProfile.id).then(data => {
          this.visibleHostsColumns = this.hostsColumns.filter(col => {
            return this.containerImagesPreferences.includes(col.label)
          })
          this.containerPreferencesFetched = true
          this.updateStoreWithPrefs()
        })
      }
    },
    updateStoreWithPrefs () {
      this.containerColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleHostsColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.containerColumnPrefs)
    }
  },
  created () {
    this.changeFilterSelection = _.debounce((field, event) => {
      this.filterTableBy(field)
    }, 250)

    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }
    if (!this.$_.isEmpty(this.$route.query.agentId)) {
      tableMetaData.searchTags.push(this.$route.query.agentId)
    }
    if (!this.$_.isEmpty(this.$route.query.status)) {
      tableMetaData.searchTags.push(this.$route.query.status)
    }
    if (!this.$_.isEmpty(this.$route.query.state)) {
      tableMetaData.searchTags.push(this.$route.query.state)
    }
    if (!this.$_.isEmpty(this.$route.query.upgradeable)) {
      tableMetaData.searchTags.push(this.$route.query.upgradeable)
    }
    this.callApi(tableMetaData).then(() => {
      if (this.$route.query.protected) {
        this.filterTableBy('protected')
      } else if (this.$route.query.atrisk) {
        this.filterTableBy('atrisk')
      } else if (this.$route.query.vulnerable) {
        this.filterTableBy('vulnerable')
      }
    })
    this.visibleHostsColumns = this.hostsColumns

    this.loadContainerColumnPreferences()
  },
  computed: {
    ...mapGetters([
      'containerImagesListReqStatus',
      'containerImagesListInfo',
      'containerImagesListSummary',
      'userProfile',
      'containerImagesPreferences',
      'userPref',
      'agentList'
    ]),
    hostStatusOptions () {
      return HostStatusEnum.properties
    },
    hostSensorOptions () {
      return OnOffEnum.properties
    },
    criticalityOptions () {
      return CriticalityLevelEnum
    }
  },
  components: {
    PageHeaders,
    TableToolbar,
    ExpandableMultiSelectTableElement,
    ExpandableTableElement,
    AsideSidebar,
    HostDetailsFeed
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/global_classes.css';
@import 'assets/styles/icon.css';
@import 'assets/styles/accounts_list.css';

.table-toolbar {
  .el-button:last-of-type {
    .c-icon {
      border-left: 1px solid var(--border-color);
      padding-left: 10px;
    }
  }
}

>>> .el-radio {
  margin: 10px;
  line-height: 20px;

  .el-radio__label {
    vertical-align: middle;

    i {
      vertical-align: middle;
    }
  }
}

>>> .el-tag {
  border: none;
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

.disabled {
  color: var(--tuna-400);
  cursor: not-allowed;
  .c-icon {
    color: var(--tuna-400);
  }
}

.el-button {
  background-color: var(--denim-600);
  color: white;
}

.filter-button-group {
  .el-button {
    background-color: white;
    color: var(--gray-800);
    margin-bottom: 25px;

    &.active {
      background-color: var(--denim-600);
      color: white;
    }
  }

  >>> .el-input {
    input {
      border-radius: 20px;
      width: 102px;
      height: 37px;
    }
  }
}

.vulnerable-tooltip {
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
}

.text-btn {
  cursor: pointer;
  color: #1a90fa;
  font-size: 11px;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
}

.filter-input {
  display: table-cell;
}

>>> .search-box-container {
  position: relative;
  right: 8.5%;
}

.filter-name-validator {
  position: absolute;
  top: 34px;
  left: 3px;
  color: red;
  width: 110px;
}

.relative-pos {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/hosts/ContainerImagesListView.vue